<form [formGroup]="form">
  <div class="my-3 my-md-5  border rounded-3 shadow bg-light g-4">
    <div class="row p-3 g-4">
      <div class="col-12 col-md-6">
        <span class="form-label">Категория*</span>
        <ng-select
          id="adCategoryId"
          [clearable]="false"
          [searchable]="false"
          [items]="adCategories"
          bindValue="adCategoryId"
          bindLabel="adCategoryName"
          formControlName="adCategoryId"
          notFoundText="Няма намерени категории"
          placeholder="Изберете категория"
          [class.is-valid]="adCategoryId?.touched && adCategoryId?.valid"
          [class.is-invalid]="adCategoryId?.touched && adCategoryId?.invalid">
          <ng-template ng-option-tmp let-item="item">
            <div>
              <div>{{ item.adCategoryName }}</div>
              <small class="mb-0 text-muted">{{ item.adCategoryDescription }}</small>
            </div>
          </ng-template>
        </ng-select>
        @if (adCategoryId?.touched && adCategoryId?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
        <small class="text-muted">
          Изберете подходяща категория, към която принадлежи артикулът.
        </small>
      </div>
      <div class="col-12 col-md-6">
        <span class="form-label">Подкатегория*</span>
        <ng-select
          id="adSubcategoryId"
          [clearable]="false"
          [searchable]="false"
          [items]="filteredAdSubcategories"
          bindValue="adSubcategoryId"
          bindLabel="adSubcategoryName"
          formControlName="adSubcategoryId"
          notFoundText="Няма намерени подкатегории"
          placeholder="Изберете подкатегория"
          [class.is-valid]="adSubcategoryId?.touched && adSubcategoryId?.valid"
          [class.is-invalid]="adSubcategoryId?.touched && adSubcategoryId?.invalid">
        </ng-select>
        @if (adSubcategoryId?.touched && adSubcategoryId?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
        <small class="text-muted">
          Изберете подходяща подкатегория, към която принадлежи артикулът.
        </small>
      </div>
      @for (specification of adSubcategoryAssociatedSpecifications; track specification.adSpecificationId) {
        <div class="col-12 col-md-6">
          <span>{{ specification.adSpecificationName }}</span>
          <ng-select
            bindValue="adSpecificationOptionId"
            bindLabel="adSpecificationOptionName"
            notFoundText="Няма намерени резултати"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="adSpecifications[specification.adSpecificationId]"
            [items]="adSpecificationOptions[specification.adSpecificationId]"
            [clearable]="true"
            [searchable]="specification.isSelectSearchable"
            [placeholder]="getPlaceholder(specification.adSpecificationName)"
            (change)="onChangeAdSpecifications()"/>
        </div>
      }
    </div>
  </div>
  <div class="my-3 my-md-5 border rounded-3 shadow bg-light">
    <div class="row p-3 g-4">
      <div class="col-12 col-md-9">
        <label for="title" class="mb-0 form-label">Заглавие*</label>
        <input
          id="title"
          type="text"
          maxlength="100"
          formControlName="title"
          class="form-control"
          placeholder="Въведете заглавие..."
          [class.is-valid]="title?.touched && title?.valid"
          [class.is-invalid]="title?.touched && title?.invalid">
        <p class="invalid-feedback m-0">Задължително поле с максимална дължина от 100 символа!</p>
        <small class="text-muted">
          Въведете кратко заглавие до 100 символа с ключови думи за артикула.
        </small>
      </div>
      <div class="col-12 col-md-3">
        <label for="identifier" class="mb-0 form-label">Идентификатор</label>
        <button
          type="button"
          (click)="showIdentifierInfo()"
          class="btn btn-link text-dark p-0">
          <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
        </button>
        <input
          id="identifier"
          type="text"
          maxlength="20"
          class="form-control"
          formControlName="identifier"
          placeholder="Въведете идентификатор...">
        <small class="text-muted">
          Въведете идентификатор до 20 символа.
        </small>
      </div>
      <div class="col-12">
        <label for="description" class="mb-0 form-label">Описание</label>
        <textarea
          rows="3"
          id="description"
          maxlength="2000"
          class="form-control"
          formControlName="description"
          placeholder="Въведете описание на артикула до 2000 символа..."></textarea>
      </div>
    </div>
  </div>
  <div class="my-3 my-md-5  border rounded-3 shadow bg-light g-4">
    <div class="row p-3 g-4">
      <div class="col-12">
        <span class="mb-1 form-label">Снимки*</span>
        <ul
          cdkDropList
          cdkDropListOrientation="mixed"
          (cdkDropListDropped)="dropImage($event)"
          class="list-unstyled row row-cols-2 row-cols-md-3 row-cols-lg-5 g-3 me-5 me-md-0">
          @for (image of previewImages; track index; let index = $index) {
            <div cdkDrag class="col image position-relative">
              <div class="border rounded-3 overflow-hidden image">
                <div *cdkDragPlaceholder
                     class="image-placeholder rounded-3 bg-body-secondary d-flex align-items-center justify-content-center fw-bold text-muted">
                  Пусни тук
                </div>
                <nz-image [imageUrl]="image.imageUrl"/>
              </div>
              <div class="pe-2 position-absolute top-0 end-0">
                <button
                  type="button"
                  class="p-2 m-1 btn btn-close btn-sm bg-body"
                  (click)="onRemoveImage(index)">
                </button>
              </div>
            </div>
          }
          @if (previewImages.length < 10) {
            <li class="col">
              <button
                type="button"
                class="btn btn-light border rounded-3 w-100 add-image-button"
                (click)="fileInput.click()">
                <i class="fa fa-camera fs-3 text-muted"></i>
                <div>Добави снимки</div>
                <small class="text-primary">{{ previewImages.length }}/10</small>
              </button>
            </li>
          }
        </ul>
        <input
          multiple
          #fileInput
          id="images"
          type="file"
          accept="image/*"
          class="d-none form-control"
          (change)="onSelectImages($event)"
          [class.is-valid]="imagesCount?.touched && imagesCount?.valid"
          [class.is-invalid]="imagesCount?.touched && imagesCount?.invalid"/>
        <p class="invalid-feedback m-0">Задължително е прикачването на поне една снимка!</p>
        <small class="mb-2 text-muted">
          Прикачете снимки на артикула. Имате възможност да добавите до 10 снимки, като първата от тях ще бъде основна.
        </small>
      </div>
    </div>
  </div>
</form>
